<mat-form-field appearance="outline" class="w-100 mb-2 compact-inputs dropdown-pd-none">
  <input type="text" matInput [required]="e['required'] == 1" [type]="e.type" [(ngModel)]="entryData"
    (input)="onUserInput($event)" (blur)="hideDropdownDelayed()" [id]="e.code + '_input'" [name]="e.code + '_input'"
    [readonly]="readonly" [matAutocomplete]="auto" placeholder="Add / Search" />

  <button mat-icon-button matSuffix type="button" (click)="toggleDropdown()" [disabled]="readonly" class="icon-pd-none">
    <mat-icon>add</mat-icon>
  </button>

  <mat-autocomplete #auto="matAutocomplete">
    <mat-option *ngFor="let c of filteredValues" [value]="c" (onSelectionChange)="selectItem(c)">
      {{ c }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
